import {CHANGE_REDIRECT_URL} from "./constants";

export function changeRedirectState(redirectState) {
    return {
        type: CHANGE_REDIRECT_URL,
        redirectState: redirectState
    }
}


// WEBPACK FOOTER //
// ./src/redux/global/redirect/actions.js